import React from "react";

export default function InfoBox(props) {

  function getFormatTime(timeStamp) {
    let hours = timeStamp.getHours();
    let minutes = timeStamp.getMinutes();

    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
  }

  let sunrise = getFormatTime(props.data.sunrise);
	let sunset = getFormatTime(props.data.sunset);
	
	//console.log(`InfoBox ${props}`)

  return (
    <div className="col-4 m-auto info">
      <div className="p-2 small">
        max:{" "}
        <span id="max-temp" className="fw-bold">
          {Math.round(props.data.maxTemp)}ºC{" "}
        </span>
        min:{" "}
        <span id="min-temp" className="fw-bold">
          {Math.round(props.data.minTemp)}ºC
        </span>
        <hr className="m-1" />
        humidity:{" "}
        <b>
          <span id="hum">{props.data.humidity}</span>%
        </b>
        <br />
        wind:{" "}
        <b>
          <span id="wind-speed">{props.data.wind}</span> m/s{" "}
        </b>
        <br />
        pressure:{" "}
        <b>
          <span id="pressure">{props.data.pressure}</span> hPa{" "}
        </b>
        <hr className="m-1" />
        sunrise:{" "}
        <span id="sunrise" className="fw-bold">
          {sunrise}
        </span>{" "}
        UTC
        <br />
        sunset:{" "}
        <span id="sunset" className="fw-bold">
          {sunset}
        </span>{" "}
        UTC
      </div>
    </div>
  );
}
